/* eslint-disable radix */
// import { FaCheck, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { getMyWriters, getSocieties } from '../../../../api/queries';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
import Input from '../../../../components/input';
import LoadingSmall from '../../../../components/loadingSmall';
import Select from '../../../../components/select';
import { strToBool } from '../../../../helpers/helpers';
import AppState from '../../../../store/appstate';

function SongWriterSplitCreate({
  writer, last, setWriterField, i, deleteSongWriter,
}) {
  const { t } = useTranslation('songs');
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const writers = getMyWriters({ aac: selectedAccount });

  const societies = getSocieties();

  const designationCodes = [
    { name: t('songs:author-option'), value: 1 },
    { name: t('songs:composer-option'), value: 2 },
    { name: t('songs:both-option'), value: 3 },
  ];

  if (!writers.isSuccess || !societies.isSuccess) {
    return (<LoadingSmall />);
  }

  const writerDetails = writers.data.writers.find((w) => w.writercode === writer.writercode);

  const society = societies.data.societies.find((s) => s.cisaccode === writerDetails?.societycisaccode);

  const writerType = designationCodes.find((d) => d.value === parseInt(writer?.writerdesignationcode));

  if (writer.isdeleted) {
    return <></>;
  }

  return (
    <div className={`flex flex-wrap items-center py-2  ${last ? '' : 'border-b border-sentric-menu-gray'} `}>
      <div className="lg:w-4/12 w-full lg:mb-0 mb-2">
        <h2 className="text-base font-semibold text-sentric-table-text">
          {writerDetails?.firstname}
          {' '}
          {writerDetails?.middlename}
          {' '}
          {writerDetails?.lastname}
        </h2>
        <p className="text-xs">
          {t('songs:membership')}
          :
          {' '}
          {society?.name}
          <span className="ml-2 mr-2">|</span>
          CAE / IPI #:
          {' '}
          {writerDetails?.caeipinumber ? writerDetails.caeipinumber : '-'}
          <br />
          {t('songs:publisher')}
          :
          {' '}
          {writerDetails?.publishername ? writerDetails.publishername : '-'}
        </p>
      </div>
      <div className="lg:w-3/12 w-full lg:mb-0 mb-2">
        <Select
          id={`btnSongWriterSplitRole_${i}`}
          className="w-full pr-4 text-sentric-dark-gray"
          name="writerdesignationcode"
          placeholder={t('songs:select-role')}
          value={writerType?.value}
          onChange={(selected) => setWriterField({ writercode: writer.writercode, field: 'writerdesignationcode', value: selected })}
          options={[
            // { name: 'Unknown', value: 0 },
            { name: t('songs:author-option'), value: 1 },
            { name: t('songs:composer-option'), value: 2 },
            { name: t('songs:both-option'), value: 3 },
          ]}
        />
      </div>
      <div className="lg:w-5/12 w-full flex-wrap flex justify-between items-center text-sm">
        <div className="ml-0 lg:w-32 w-full lg:mb-0 mb-2">
          <Input
            id={`btnSongWriterSplitPercent_${i}`}
            min="0"
            max="100"
            type="number"
            placeholder="%"
            value={writer?.writershare}
            onKeyDown={(e) => {
              if (e.keyCode === 69 || e.keyCode === 107
                || e.keyCode === 187 || e.keyCode === 109 || e.keyCode === 189) {
                e.preventDefault();
              }
            }}
            onChange={(e) => setWriterField({ writercode: writer.writercode, field: 'writershare', value: e.target.value })}
            onBlur={(e) => setWriterField({ writercode: writer.writercode, field: 'writershare', value: parseFloat(e.target.value).toFixed(2) })}
          />
        </div>
        <div className="ml-2 lg:w-32 w-full lg:mb-0 mb-1">
          <label className="" htmlFor={`righttocollect${i}`}>
            <input
              data-tip
              data-for="tipregistertocollect"
              type="checkbox"
              id={`righttocollect_${i}`}
              name={`righttocollect${i}`}
              checked={strToBool(writer?.righttocollect)}
              className="mr-4"
              onChange={(e) => setWriterField({ writercode: writer.writercode, field: 'righttocollect', value: e.target.value })}
            />
            {t('songs:right-to-collect')}

          </label>
          <ReactTooltip id="tipregistertocollect" place="right" type="warning" effect="solid" multiline="true" class="mw-20">
            <center>
              {t('songs:right-to-collect-tooltip')}
            </center>
          </ReactTooltip>
        </div>
        <div className="ml-2">
          <ButtonPrimaryText id={`btnSongWriterSplitremove_${i}`} onClick={() => deleteSongWriter(writer.writercode)}>{t('songs:remove-link')}</ButtonPrimaryText>
        </div>
      </div>
    </div>
  );
}

export default SongWriterSplitCreate;
